import InputTypes from '../../../core/enums/InputTypes';

const metaInputs = [
    {
        name: 'numMeta',
        label: 'Nº Meta',
        type: InputTypes.INTEGER,
        table: { use: true },
        filter: { use: true },
    },
    {
        name: 'contaAcessoCadastro',
        label: 'Usuário',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'contaAcessoCadastro.nome' },
    },
    {
        name: 'periodicidadeMeta',
        label: 'Periodicidade',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'periodicidadeMeta.siglaPeriodicidade' },
        form: { use: true },
    },
    {
        name: 'unidadeMedidaMeta',
        label: 'Unidade de Medida',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'unidadeMedidaMeta.descUnidadeMedida' },
        form: { use: true },
    },
    {
        name: 'descMeta',
        label: 'Meta',
        type: InputTypes.STRING,
        table: { use: true },
        filter: { use: true },
        form: { use: true, validate: { required: true, max: 20 } },
    },
    {
        name: 'dataPrevisaoApuracao',
        label: 'Previsão de Apuração',
        type: InputTypes.DATE,
        table: { use: true },
        form: { use: true, validate: { required: true } },
    },
    {
        name: 'situacao',
        label: 'Situação da Meta',
        type: InputTypes.STRING,
        filter: { use: true, nameUse: 'situacao.id' },
        form: { use: true },
    },
    {
        name: 'situacaoTable',
        label: 'Situação da Meta',
        type: InputTypes.STRING,
        table: { use: true, nameUse: 'situacao.descSituacaoMeta' },
    },
    {
        name: 'analistaNegocial',
        label: 'Analista Negocial',
        type: InputTypes.INTEGER,
        table: { use: true, nameUse: 'avaliacaoMeta.analistaNegocial.nomePessoa' },
    },
    {
        name: 'indicador',
        label: 'Indicador',
        type: InputTypes.ENTITY,
        filter: { use: true, nameUse: 'indicador.id' },
    },
].map((el) => ({
    ...el,
    export: el?.name !== 'contaAcessoCadastro' ? el?.table ?? { use: false } : undefined,
}));

export { metaInputs };
